import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './d0f4ef905db6ff4aa2210fbf8d7198de6be0f13a621b3369ac7134651a7e3c08.cfe-internal.js';

var _excluded = ["color", "onClick", "className"];
var ENTER = 13;
var Swatch = function Swatch(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#000000' : _ref$color,
    onClick = _ref.onClick,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  function handleClick(e) {
    onClick === null || onClick === void 0 || onClick(color, e);
  }
  var handleKeyDown = function handleKeyDown(e) {
    return e.keyCode === ENTER && (onClick === null || onClick === void 0 ? void 0 : onClick(color, e));
  };
  return /*#__PURE__*/React__default.createElement("span", _extends({}, rest, {
    role: "button",
    tabIndex: 0,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    className: classNames(styles.swatch, className),
    style: {
      backgroundColor: color
    }
  }));
};

export { Swatch as default };
